import React from 'react';

export default function Logo() {
  return (
    <svg
      width="475"
      height="142"
      viewBox="0 0 475 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M137 99.865V68.0472C137 59.0255 142.898 57.1728 145.847 57.3742C158.065 56.0145 160.04 78.5166 159.464 92.0617C160.56 84.1575 167.361 84.1575 167.361 84.1575C169.572 83.4862 174.639 84.077 177.213 91.8099C178.687 86.7083 181.395 72.6789 180.43 57.3742C178.821 23.3815 193.164 33.8129 200.536 43.2777C203.15 45.4929 206.809 60.5157 200.536 102.886C194.263 145.256 174.197 132.22 164.948 120.406C144.841 141.832 137.938 115.64 137 99.865Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.956 49.4481C208.635 66.4938 175.789 106.515 198.974 130.233C222.159 153.951 245.424 136.401 254.158 124.661C257.995 115.508 260.947 100.346 242.049 112.922C239.336 114.58 233.315 116.583 230.933 111.33C227.956 104.764 229.345 101.182 232.72 98.3964C233.011 98.1558 233.403 97.8485 233.875 97.4785C238.869 93.564 252.812 82.634 251.18 69.5447C249.394 55.2184 238.873 38.7033 227.956 49.4481ZM236.094 69.5447C230.999 71.0702 221.207 75.9518 222.795 83.2741C228.154 84.6006 238.317 83.7119 236.094 69.5447Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.6821 55.1283C40.824 55.4648 11.6144 65.063 5.64059 100.763C-1.82663 145.389 58.3148 138.523 65.1765 123.985C73.451 129.437 90 136.383 90 120.552V48.8686C88.9909 35.1378 83.7437 8.16064 70.8274 10.0991C54.6821 12.5222 54.6821 44.6282 54.6821 55.1283ZM56.4984 107.023V76.1285C53.8748 76.465 48.1028 78.9958 46.0039 86.4266C42.7749 102.096 51.6548 106.686 56.4984 107.023Z"
        fill="black"
      />
      <path
        d="M121.04 100.874C132.554 130.219 116.243 132.718 106.648 130.3C78.0906 115.337 93.4947 44.332 100.211 18.444C102.26 10.0599 109.254 9.30743 112.27 10.3823C125.942 12.1559 125.163 31.8129 123.289 41.0166C118.611 64.3955 119.841 90.663 121.04 100.874Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.879 17.1269C256.758 21.2436 247.354 39.7954 250.705 81.0686C254.057 122.342 271.123 130.137 279.237 128.875C286.42 129.141 302.421 125.051 308.966 106.566C315.51 88.0803 309.963 68.1873 306.372 60.5515C300.586 50.2598 286.579 35.0944 276.843 56.7668C276.178 42.6239 272.254 14.896 261.879 17.1269ZM289.014 115.529C275.127 99.4344 280.434 82.2638 284.824 75.6904C287.351 76.6199 292.884 81.8256 294.8 95.2115C296.715 108.597 291.74 114.334 289.014 115.529Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.784 50.8325V24.9179C330.513 8.37815 336.579 -14.7776 363 24.9179V122.951C360.366 129.915 352.302 140.188 341.117 125.563C333.89 130.719 316.276 137.014 303.633 120.942C287.829 100.854 301.607 60.2742 330.784 50.8325ZM330.784 109.693C319.275 99.0858 325.178 84.2469 329.568 78.1533C331.391 79.0908 335.241 84.0594 336.052 96.4341C336.862 108.809 332.877 110.429 330.784 109.693Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M367.025 69.3109C375.01 58.995 393.599 41.2382 404.068 52.7388C414.536 64.2395 398.632 81.8898 389.371 89.2774C384.808 93.071 379.346 102.016 394.002 107.447C399.169 107.713 409.664 107.766 410.309 105.85C414.805 111.041 416.912 122.462 389.371 126.615C354.945 131.806 353.335 83.0788 367.025 69.3109ZM392.592 63.321C389.103 62.3227 381.842 63.2411 380.715 74.9015C386.352 73.9698 396.619 70.3492 392.592 63.321Z"
        fill="black"
      />
      <path
        d="M472.628 46.7974C456.104 37.1942 440.476 68.4047 434.728 85.2103C440.343 44.8768 424.634 51.4657 416.078 59.8018C413.538 63.3363 411.266 78.168 422.495 109.218C433.725 140.269 450.035 121.222 456.786 107.818C478.444 69.7251 476.371 51.2656 472.628 46.7974Z"
        fill="black"
      />
      <path
        d="M133 98.1929V66.6998C133 57.7701 138.898 55.9364 141.847 56.1357C154.065 54.7898 156.04 77.0624 155.464 90.4692C156.56 82.6457 163.361 82.6457 163.361 82.6457C165.572 81.9813 170.639 82.566 173.213 90.22C174.687 85.1704 177.395 71.2843 176.43 56.1357C174.821 22.4899 189.164 32.8148 196.536 42.183C199.15 44.3756 202.809 59.2451 196.536 101.183C190.263 143.12 170.197 130.218 160.948 118.524C140.841 139.732 133.938 113.807 133 98.1929Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.515 47.484C203.902 64.7072 170.559 105.145 194.095 129.11C217.631 153.075 241.248 135.343 250.115 123.481C254.011 114.232 257.006 98.9124 237.823 111.619C235.069 113.294 228.956 115.318 226.538 110.01C223.515 103.376 224.926 99.7568 228.352 96.9422C228.648 96.6991 229.045 96.3886 229.525 96.0148C234.594 92.0594 248.749 81.0156 247.092 67.79C245.278 53.3144 234.598 36.6273 223.515 47.484ZM231.777 67.79C226.605 69.3314 216.664 74.2638 218.276 81.6624C223.717 83.0027 234.034 82.1047 231.777 67.79Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.0976 53.7673C36.4025 54.1011 7.53655 63.6225 1.63305 99.0372C-5.74632 143.305 53.6875 136.495 60.4686 122.073C68.6457 127.481 85 134.372 85 118.667V47.5577C84.0028 33.9367 78.8173 7.17535 66.053 9.09832C50.0976 11.502 50.0976 43.3512 50.0976 53.7673ZM51.8926 105.247V74.5994C49.2998 74.9333 43.5957 77.4438 41.5215 84.8152C38.3305 100.359 47.1059 104.913 51.8926 105.247Z"
        fill="#FFCA2E"
      />
      <path
        d="M85 118.667C85 134.372 68.6457 127.481 60.4686 122.073C53.6875 136.495 -5.74632 143.305 1.63305 99.0372C7.53655 63.6225 36.4025 54.1011 50.0976 53.7673C50.0976 43.3512 50.0976 11.502 66.053 9.09832C78.8173 7.17535 84.0028 33.9367 85 47.5577M85 118.667C85 102.963 85 64.7175 85 47.5577M85 118.667V47.5577M51.8926 74.5994V105.247C47.1059 104.913 38.3305 100.359 41.5215 84.8152C43.5957 77.4438 49.2998 74.9333 51.8926 74.5994Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M116.927 99.1235C128.769 128.225 111.992 130.704 102.124 128.305C72.7503 113.466 88.5945 43.0483 95.5022 17.3742C97.61 9.05936 104.804 8.31315 107.906 9.37916C121.969 11.1381 121.167 30.6326 119.24 39.7603C114.429 62.9459 115.693 88.9964 116.927 99.1235Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M257.07 15.1281C251.867 19.2815 242.311 37.9989 245.717 79.6407C249.123 121.282 266.464 129.147 274.709 127.874C282.007 128.142 298.267 124.016 304.917 105.365C311.567 86.7149 305.93 66.6444 302.281 58.9404C296.402 48.5567 282.169 33.2559 272.276 55.1219C271.6 40.8527 267.613 12.8772 257.07 15.1281ZM284.643 114.409C270.532 98.1704 275.925 80.8465 280.385 74.2144C282.953 75.1523 288.576 80.4044 290.522 93.9098C292.468 107.415 287.414 113.203 284.643 114.409Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M326.272 49.8325V23.9179C326.006 7.37815 331.979 -15.7776 358 23.9179V121.951C355.406 128.915 347.464 139.188 336.449 124.563C329.332 129.719 311.984 136.014 299.532 119.942C283.967 99.8536 297.537 59.2742 326.272 49.8325ZM326.272 108.693C314.937 98.0858 320.751 83.2469 325.074 77.1533C326.87 78.0908 330.662 83.0594 331.46 95.4341C332.258 107.809 328.334 109.429 326.272 108.693Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M362.025 67.5713C370.01 57.1231 388.599 39.1386 399.068 50.7867C409.536 62.4349 393.632 80.3115 384.371 87.7937C379.808 91.636 374.346 100.696 389.002 106.196C394.169 106.466 404.664 106.52 405.309 104.578C409.805 109.836 411.912 121.403 384.371 125.61C349.945 130.867 348.335 81.5157 362.025 67.5713ZM387.592 61.5046C384.103 60.4935 376.842 61.4237 375.715 73.2336C381.352 72.2899 391.619 68.6229 387.592 61.5046Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M468.628 44.8196C452.104 35.0979 436.476 66.6936 430.728 83.7067C436.343 42.8753 420.634 49.5455 412.078 57.9845C409.538 61.5627 407.266 76.5774 418.495 108.011C429.725 139.445 446.035 120.163 452.786 106.593C474.444 68.0304 472.371 49.343 468.628 44.8196Z"
        fill="#FFCA2E"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
}
